import { api } from '../index';

const prefix = '/api/promotion/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectPromotionList(param) {
	return api.post(prefix + 'selectPromotionList', param);
}

export function apiSelectPromotion(param) {
	return api.post(prefix + 'selectPromotion', param);
}

export function apiSelectPromotionClassList(param) {
	return api.post(prefix + 'selectPromotionClassList', param);
}

export function apiInsertPromotion(param) {
	param.mode = 'insert';
	return apiSubmitPromotion(param);
}

export function apiUpdatePromotion(param) {
	param.mode = 'update';
	//console.log(param);
	return apiSubmitPromotion(param);
	//return api.post(prefix + 'submitUser', param);
}

function apiSubmitPromotion(param) {
	return api.post(prefix + 'submitPromotion', param);
}

export function apiUpdatePromotionClasses(param) {
	return api.post(prefix + 'updatePromotionClasses', param);
}

// #3406 : config 는 State 제한 사용자의 SO 상세가 차단 응답을 화면에서 흡수할 때만 넘긴다.
export function apiSelectNotSoldPromotionList(param, config) {
	return api.post(prefix + 'selectNotSoldPromotionList', param, config);
}

export function apiSelectActivePromotionClassCodes(param) {
	return api.post(prefix + 'selectActivePromotionClassCodes', param);
}
